import React, { Component } from 'react'
import Section from '../shared/Section'
import Header from './Header'
import Slider from './Slider'
import bottomShape from './bottom-shape.png'
import topShape from './top-shape.png'
import { extendBaseClass, getClassWithVariant } from '../../utils/classes'

export class Pricing extends Component {
  baseClass = 'pricing'

  extend = extendBaseClass.bind(this)

  getImageClass = (variant) => {
    const baseClass = this.extend('image')
    return getClassWithVariant(variant, baseClass)
  }

  render() {
    return (
      <Section extraClasses={this.baseClass}>
        <img src={topShape} alt="#" className={this.getImageClass('top')} />
        <Header parentClass={this.baseClass} />
        <Slider parentClass={this.baseClass} />
        <img
          src={bottomShape}
          alt="#"
          className={this.getImageClass('bottom')}
        />
      </Section>
    )
  }
}

export default Pricing
